import React, { useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { FaEdit, FaPlus } from "react-icons/fa";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import DesignationTableModalContent from "../ModalContent/DesignationTableModalContent";
import { useGetDesignation } from "./hooks/useSettingsMasters";

interface formDataInteface {
  name: string | number;
  designationColor: string | number;
}

const DesignationDataColumns = (handleEdit: (row: any) => void) => [
  {
    name: "Designation",
    selector: (row: { Designation: string }) => row?.Designation || "-",
    sortable: true,
    maxwidth: "210px",
  },
  {
    name: "Action",
    width: "100px",
    cell: (row: any) => (
      <button
        onClick={() => handleEdit(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

const Designation = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalStatus, setModalStatus] = useState<string>("");
  const [selectedRow, setSelectedfRow] = useState(null);
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    search: null,
  });
  const [designationId, setDesignationId] = useState<string | number>("");
  const [formData, setformData] = useState<formDataInteface>({
    name: "",
    designationColor: "",
  });

  const { data: designationData } = useGetDesignation({
    enable: true,
    params: {
      page: filtersState?.page,
      limit: filtersState?.limit,
      search: filtersState?.search,
      fetch: "",
    },
  });

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setformData({
      name: "",
      designationColor: "",
    });
    setModalStatus("");
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setformData({
      name: "",
      designationColor: "",
    });
    setModalStatus("");
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleEdit = (row: any) => {
    console.log("🚀 ~ Designation.tsx:107 ~ handleEdit ~ row:", row);

    setIsModalOpen(!isModalOpen);
    setModalStatus("Edit");
    setSelectedfRow(row);
    setDesignationId(row?.DesignationId);
  };

  return (
    <div className="container mt-3">
      <BasicDataTable
       minHeightOfTable={630}
        Title="Designation"
        data={designationData?.data?.DesignationData || []}
        columns={DesignationDataColumns(handleEdit)}
        search={false}
        headerContent={
          <button
            onClick={() => toggleModal()}
            className="btn btn-info"
            style={{
              borderRadius: "20px",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <FaPlus /> <span>Add Designation</span>
          </button>
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={designationData?.data?.Pagination?.TotalCount || 0}
      />
      <RouteModal
        isOpen={isModalOpen}
        title="Add Designation"
        toggle={toggleModal}
        size="md"
        content={
          <DesignationTableModalContent
            handleClose={handleClose}
            modalStatus={modalStatus}
            selectedRow={selectedRow}
            setformData={setformData}
            formData={formData}
            designationId={designationId}
          />
        }
      />
    </div>
  );
};

export default Designation;
